(() => {
  class FloatingFlowers {
    constructor(root) {
      this.root = root;
      this.lastScrollY = window.scrollY;
      this.lastSpawn = 0;
      this.enabled = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.isTouch = window.matchMedia('(pointer: coarse)').matches;
      this.palette = [
        ['#f7b6c6', '#f6cf55'],
        ['#fff0a8', '#d78a42'],
        ['#f39f8f', '#f7d05f'],
        ['#ffffff', '#e6b54f'],
        ['#d9a7d8', '#f5ce69']
      ];

      if (!this.enabled) return;

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    onScroll() {
      const currentY = window.scrollY;
      const distance = Math.abs(currentY - this.lastScrollY);
      this.lastScrollY = currentY;

      if (distance < 8) return;

      const now = window.performance.now();
      const interval = this.isTouch ? 220 : 110;

      if (now - this.lastSpawn < interval) return;

      this.lastSpawn = now;
      this.spawnFlower(Math.random() * window.innerWidth, distance);
    }

    spawnFlower(x, distance) {
      const flower = document.createElement('span');
      const colors = this.palette[Math.floor(Math.random() * this.palette.length)];
      const size = this.random(18, this.isTouch ? 34 : 46);
      const drift = this.random(-90, 90);
      const travel = Math.min(window.innerHeight * 0.85, this.random(220, 420) + distance * 6);
      const duration = this.random(2600, 4300);

      flower.className = 'floating-flower';
      flower.style.setProperty('--flower-x', `${Math.max(16, Math.min(window.innerWidth - 16, x))}px`);
      flower.style.setProperty('--flower-size', `${size}px`);
      flower.style.setProperty('--flower-drift', `${drift}px`);
      flower.style.setProperty('--flower-travel', `${travel}px`);
      flower.style.setProperty('--flower-duration', `${duration}ms`);
      flower.style.setProperty('--flower-rotate', `${this.random(-36, 36)}deg`);
      flower.style.setProperty('--flower-spin', `${this.random(-140, 140)}deg`);
      flower.style.setProperty('--flower-opacity', `${this.random(0.42, 0.72)}`);
      flower.style.setProperty('--flower-petal', colors[0]);
      flower.style.setProperty('--flower-center', colors[1]);
      flower.innerHTML = '<span class="floating-flower__petal"></span><span class="floating-flower__petal"></span><span class="floating-flower__petal"></span><span class="floating-flower__petal"></span><span class="floating-flower__petal"></span><span class="floating-flower__center"></span>';

      this.root.appendChild(flower);
      flower.addEventListener('animationend', () => flower.remove(), { once: true });
    }

    random(min, max) {
      return Math.random() * (max - min) + min;
    }
  }

  const init = () => {
    document.querySelectorAll('[data-floating-flowers]').forEach((root) => new FloatingFlowers(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
